
import toast from '../components/toast/toast.js'
import store from '../store/store.js'
import {getData, postData, getAysnDataSucc, getDataSuccess, apiUrl} from './api'
import {getBrowserInfo} from "../assets/js/utils.js"

export const reqHub = {
    //待领取权益列表数据重组
    interestRecombine(errorCb) {
        let _this = this;
        getDataSuccess({
            url: apiUrl.queryBenefitBaseInfo
        },(result) => {
            //业务系统状态
            if(result.code == "0") {
                /*
                 *
                 * */
                //可领取
                if(result.receivelousBenefitBaseDtos && result.receivelousBenefitBaseDtos.length>0) {
                    let arr = [];
                    let idx = 0;
                    result.receivelousBenefitBaseDtos.forEach(function (item,index) {

                        //根据id 调用权益详情接口
                        getAysnDataSucc({
                            url: apiUrl.queryBenefitDetailInfo,
                            data: {benefitCode: item.benefitCode}
                        },(detail) => {

                            //接口状态
                            if(detail.code == "0") {
                                //页面所需数据 //获取列表里的tag, 重组到页面数据里

                                //_this.uInterestData.receive.push(detail.detailInfoDto);
                                arr.push(Object.assign({}, detail.detailInfoDto, { "tag": item.tag ? item.tag : ''}))

                            }

                            if(idx == result.receivelousBenefitBaseDtos.length - 1) {
                                //_this.uInterestData.receive = arr;
                                //缓存
                                store.commit("RECEIVEINTEREST", {requested: true, list: arr});

                            }
                            idx++;
                        })
                    });


                }else {
                    //缓存
                    store.commit("RECEIVEINTEREST", {requested: true, list: []});
                }
                //未开启
                if(result.unReceivelousBenefitBaseDtos && result.unReceivelousBenefitBaseDtos.length>0) {
                    //循环不可领取权益列表id
                    let arr2 = [];
                    let idx2 = 0;
                    result.unReceivelousBenefitBaseDtos.forEach(function (item, index) {
                        //根据id 调用权益详情接口
                        getAysnDataSucc({
                            url: apiUrl.queryBenefitDetailInfo,
                            data: {benefitCode: item.benefitCode}
                        },(detail) => {
                            //接口状态
                            if(detail.code == "0") {
                                //_this.uInterestData.unreceive[index] = Object.assign({}, detail.detailInfoDto, { "tag": item.tag });
                                //_this.$set(_this.uInterestData.unreceive, index, Object.assign({}, detail.detailInfoDto, { "tag": item.tag ? item.tag : ''}));
                                arr2.push(Object.assign({}, detail.detailInfoDto, { "tag": item.tag ? item.tag : ''}))
                            }

                            if(idx2 == result.unReceivelousBenefitBaseDtos.length - 1) {
                                //_this.uInterestData.unreceive = arr;
                                //缓存
                                store.commit("UNRECEIVEINTEREST", {requested: true, list: arr2});
                            }
                            idx2++;
                        })
                    })
                }else {
                    //缓存
                    store.commit("UNRECEIVEINTEREST", {requested: true, list: []});
                }

            }else{
                //toast({message: result.msg});
                errorCb && errorCb();
                console.error(result.msg)
            }
        })

    },
    //领取权益
    getInterest(item, index, channel, callback) {

        let receiveList = []
        if(item.jumpUrl && item.jumpUrl != "") { //跳转
            window.location.href = item.jumpUrl;
        }else {
            if(item.benefitType == "1") { //白条券 直接领取

                //领取接口
                getDataSuccess({
                    url: apiUrl.benefitSend,
                    data: {benefitCode: item.benefitCode, channel: channel}
                }, (res) => {

                    if(res.code == "0") {
                        //toast({"message": "领取成功"});

                        callback && callback();

                    }else{
                        toast({"message": res.msg})
                    }
                })
            }
        }
    },
    taskReceive(task, callback) { //领取任务

        getDataSuccess({
            url: apiUrl.jrmReceiveMission,
            data: {'missionId': task.id, 'missionLogId': task.missionLogId}
        }, (res) => {

            // if (res.resData.missionCode == 100) {
            //     toast({message: "领取任务成功"});
            // }else {
            //     toast({message: "领取失败~"})
            // }
            if(res.resData.missionCode != 100 && res.resData.msg) {
                toast({message: res.resData.msg})
            }


            callback && callback();
        })
    },
    taskReward(task, callback) { //领取奖励
        getDataSuccess({
            url: apiUrl.jrmRewardMission,
            data: {'missionLogId': task.missionLogId, 'missionId': task.id}
        }, (res) => {

            // if (res.resData.missionCode == 100) {
            //     toast({message: "领取奖励成功~"});
            // }else {
            //     toast({message: "领取失败~"})
            // }
            if(res.resData.missionCode != 100 && res.resData.msg) {
                toast({message: res.resData.msg})
            }

            callback && callback();
        })
    },
    taskSign(task, cb) { //签到
        getDataSuccess({
            url: apiUrl.jrmSignMission,
            data: {'missionId': task.id, 'missionLogId': task.missionLogId}
        }, (res) => {
            //console.log(res);
            // if (res.resData.missionCode == 100) {
            //     toast({message: "签到成功"})
            // }else if(res.resData.missionCode == 106) {
            //     toast({message: "已经签过到了，不要顽皮哦~"});
            // }else {
            //     toast({message: "签到失败~"})
            // }
            if(res.resData.missionCode != 100 && res.resData.msg) {
                toast({message: res.resData.msg})
            }

            cb && cb(res.resData);
        })
    },
    getUserStatus(successCb, errorCb) {
        getData({
            url: apiUrl.checkLousUser
        }, (res) => { //成功
            //网关接口状态
            if(res.resultCode == 0) {
                let result = res.resultData
                //业务系统状态
                if(result.code == "0") {
                    /*
                    *
                    * */
                    successCb && successCb(result);
                }else{
                    errorCb && errorCb();
                }
            }else{
                window.vue && window.vue.$emit("gateWayError", res);
            }
        }, (error) => { //失败
            toast({message: error});
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/reqHub.js